import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function TurnSharpRightIcon(props: IconProps) {
    return <Icon {...props} iconKey={"turn_sharp_right"}/>
}
